module.exports = __webpack_public_path__ + "img/dongji_ps_19.82e2c368.jpg";